import { TextField, Tooltip } from '@material-ui/core';
import { useFormikContext } from 'formik';

import { useStyles } from './orionFormStyles';
import { OrionAppRequestValues } from './orionFormValuesTypes';
import { forwardRef, RefObject } from 'react';

type Props = {
  fieldPropName: keyof OrionAppRequestValues;
  label: string;
  placeholder: string;
  required?: boolean;
  tooltip?: string;
};

type Ref = ((instance: HTMLDivElement | null) => void) | RefObject<HTMLDivElement> | null | undefined;

export const OrionFormTextField = forwardRef(
  ({ fieldPropName, label, placeholder, required, tooltip }: Props, ref?: Ref) => {
    const classes = useStyles();
    const formik = useFormikContext<OrionAppRequestValues>();

    return (
      <>
        {tooltip ? (
          <Tooltip disableFocusListener arrow title={<h3>{tooltip}</h3>}>
            <TextField
              ref={ref}
              id={fieldPropName}
              key={fieldPropName}
              data-testid={fieldPropName}
              required={required}
              label={label}
              {...formik.getFieldProps(fieldPropName)}
              placeholder={placeholder}
              variant="outlined"
              error={Boolean(formik.errors[fieldPropName] && formik.touched[fieldPropName])}
              helperText={formik.errors[fieldPropName]}
              className={classes.componentFormGroup}
            />
          </Tooltip>
        ) : (
          <TextField
            ref={ref}
            id={fieldPropName}
            key={fieldPropName}
            data-testid={fieldPropName}
            required={required}
            label={label}
            {...formik.getFieldProps(fieldPropName)}
            placeholder={placeholder}
            variant="outlined"
            error={Boolean(formik.errors[fieldPropName] && formik.touched[fieldPropName])}
            helperText={formik.errors[fieldPropName]}
            className={classes.componentFormGroup}
          />
        )}
      </>
    );
  },
);
